/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Sign_BtnInputs */



/**
* | output |
* | --- |
* | "Sign the agreement" |
*
* @param {Nda_Sign_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_sign_btn = /** @type {((inputs?: Nda_Sign_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Sign_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Signer l'accord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Firmar el acuerdo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assinar o acordo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Firma l'accordo")
	return /** @type {LocalizedString} */ ("Sign the agreement")
});